<div (click)="clickPopover()" [class.cursor]="hasAction">
  <div *ngIf="khPopoverHeader" class="kh-popover-header d-flex justify-content-between align-items-center" [style.background-color]="headerBg">
    <ng-container [ngTemplateOutlet]="khPopoverHeader"></ng-container>
    <ng-container *ngIf="canClose" [style.color]="iconColor">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
  </div>
  <div class="kh-popover-body d-flex justify-content-between" [style.background-color]="bodyBg" [class.kh-only-body-mode]="!khPopoverHeader">
    <ng-content></ng-content>
    <ng-container *ngIf="canClose && !khPopoverHeader">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
  </div>
</div>
<ng-template #icon>
  <fa-icon class="cursor fa-lg" [class.white-close-icon]="whiteIcon" [style.color]="iconColor" [icon]="['fas','times']" (click)="closePopover()"></fa-icon>
</ng-template>
